import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

const Wrapper = styled.section<{ size: number }>`
  ${tokens.text('caption')};

  background: ${tokens.color.neutral_200};
  border-radius: 50%;
  color: ${tokens.color.text_default};

  align-items: center;
  display: flex;
  justify-content: center;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`;

const sizeInPixels = {
  m: 16,
  l: 24,
} as const;

interface OverflowProps {
  className?: string;
  number: number;
  size: 'm' | 'l';
}

export function Overflow({ className, number, size }: OverflowProps): JSX.Element {
  return (
    <Wrapper className={className} size={sizeInPixels[size]}>
      +{number}
    </Wrapper>
  );
}
